module.exports = __webpack_public_path__ + "static/media/NordfabLogo.4330cc8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/NordfabLogo.png
// module id = 282
// module chunks = 0